module.exports = __webpack_public_path__ + "img/video-player/wow@2x-6a4a15491430e2d8dbe59e95cb9b4c3e.png";